import React from 'react';
import { setForgotPassword } from '@sonifi/wb-user/store//userSlice';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getUserSSOPreference, login } from '../services/keyMaster.service';
import { useNavigate } from 'react-router';

const LoginForm = () => {
  const { checkingSSO, loginFailed, isLogin, usesSSO } = useSelector(
    (state) => state.user,
  );
  const { getValues, register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSignIn = async ({ email, password }) => {
    const res = await dispatch(
      login({ email, password: usesSSO ? null : password, usesSSO }),
    );
    res && navigate('/');
  };

  const iForgot = () => {
    dispatch(setForgotPassword(true));
  };

  const onCheckSSO = () => {
    dispatch(getUserSSOPreference(getValues('email')));
  };

  return (
    <div className="login-container">
      <form aria-label="form" onSubmit={handleSubmit(onSignIn)}>
        <div>
          <input
            {...register('email', {
              disabled: checkingSSO,
            })}
            aria-label="email"
            id="email"
            className={loginFailed && !usesSSO ? 'error' : null}
            placeholder="Email"
            type="text"
            onBlur={onCheckSSO}
          />
          {!usesSSO && (
            <input
              {...register('password', {
                disabled: checkingSSO,
              })}
              aria-label="password"
              id="password"
              className={loginFailed ? 'error' : null}
              placeholder="Password"
              type="password"
            />
          )}
          <p className="error">
            {loginFailed && !usesSSO && 'Email or password is incorrect.'}
          </p>
        </div>
        <div>
          <button
            type="submit"
            className="primary"
            title="Sign In"
            disabled={checkingSSO || isLogin}
          >
            {usesSSO ? 'Sign In Via Your Organization' : 'Sign In'}
          </button>
          <button type="button" onClick={iForgot}>
            Forgot Password?
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
